import { useTranslation } from 'react-i18next'

import { EMPTY_FUNCTION, EMPTY_OBJECT } from '../../../constants/common'
import { QA_NAME_APPLY_BTN, QA_NAME_CANCEL_BTN } from '../../../constants/qa'
import Button from '../../Button'
import { Buttons as ModalButtons, MODAL_BUTTONS_VARIANT } from '../../Modal'

function ConfirmationModalButtons({
  Cancel = Button.Outlined,
  Submit = Button.Contained,
  cancelProps: {
    qaName: cancelQaName = QA_NAME_CANCEL_BTN,
    ...cancelProps
  } = EMPTY_OBJECT,
  cancelText,
  children = null,
  isLoading,
  size = 'm',
  submitProps: {
    qaName: submitQaName = QA_NAME_APPLY_BTN,
    ...submitProps
  } = EMPTY_OBJECT,
  submitText,
  variant = MODAL_BUTTONS_VARIANT.REGULAR,
  onCancel = EMPTY_FUNCTION,
  onSubmit = EMPTY_FUNCTION,
  ...buttonsProps
}) {
  const { t } = useTranslation()

  return (
    <ModalButtons {...buttonsProps} size={size} variant={variant}>
      {Submit ? (
        <Submit
          {...submitProps}
          isLoading={isLoading}
          qaName={submitQaName}
          text={submitText || t('Modal.ApplyBtnKey')}
          onClick={onSubmit}
        />
      ) : null}
      {Cancel ? (
        <Cancel
          {...cancelProps}
          isLoading={isLoading}
          qaName={cancelQaName}
          text={cancelText || t('Modal.CancelBtnKey')}
          onClick={onCancel}
        />
      ) : null}
      {children}
    </ModalButtons>
  )
}

export default ConfirmationModalButtons
